import React from "react";
import { renderCards } from "../helpers/render";

export default function MetricsSection({
  themeColor,
  tripMetrics,
  cancelMetrics,
  passengerMetrics,
  occupancyMetrics,
  costsData,
}) {
  return (
    <>
      <div className="w-2/3 justify-between flex flex-row space-x-2 items-center">
        <div
          className="w-1/2 rounded-lg items-center p-1 flex flex-col bg-white"
          style={{
            height: "8.5rem",
            boxShadow:
              "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.06), 0 -4px 6px -1px rgba(0,0,0,0.1), 0 -2px 4px -2px rgba(0,0,0,0.06)",
          }}
        >
          <div
            className="w-full h-1/5 items-center text-center justify-center rounded-lg text-white"
            style={{ backgroundColor: themeColor }}
          >
            <div className="flex items-center justify-center gap-2 rounded-lg p-1 text-white">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21.0877 12.3358C21.4795 12.7929 21.6754 13.25 21.6754 13.9683C21.6754 15.862 21.6754 17.9515 21.6754 19.9758C21.6754 20.4982 21.153 20.9553 20.6306 20.9553H18.2799C17.7575 20.9553 17.3004 20.4982 17.3004 19.9758V18.6698H6.98318V19.9758C6.98318 20.4982 6.52609 20.9553 6.0037 20.9553H3.65295C3.06526 20.9553 2.67347 20.4982 2.67347 19.9758C2.67347 17.9515 2.67347 15.862 2.67347 13.9683C2.67347 13.25 2.86936 12.7929 3.13056 12.3358L2.28168 12.0747C0.910402 11.8788 1.30219 9.20151 3.78355 10.3769C4.43653 7.89553 4.95892 4.5 8.15856 4.5H16.0597C19.4552 4.5 19.7817 7.83023 20.5 10.3769C23.0467 9.20151 23.3079 11.8788 22.0672 12.0747L21.0877 12.3358ZM18.7369 13.6418C18.084 13.6418 17.4963 14.2295 17.4963 14.9478C17.4963 15.6661 18.084 16.1885 18.7369 16.1885C19.5205 16.1885 20.0429 15.6661 20.0429 14.9478C20.0429 14.2295 19.5205 13.6418 18.7369 13.6418ZM5.48131 13.6418C6.1996 13.6418 6.78728 14.2295 6.78728 14.9478C6.78728 15.6661 6.1996 16.1885 5.48131 16.1885C4.89362 16.1885 4.24064 15.6661 4.24064 14.9478C4.24064 14.2295 4.89362 13.6418 5.48131 13.6418ZM18.9981 10.7687C15.0802 11.8135 9.20334 11.8135 5.35071 10.7687C5.74251 9.00561 6.0037 6.00187 8.15856 6.00187H16.0597C18.2799 6.00187 18.5411 9.00561 18.9981 10.7687Z"
                  fill="white"
                />
              </svg>
              <span>Trips</span>
            </div>
          </div>
          <div className="h-full flex flex-row space-x-1 items-center justify-center w-full">
            {renderCards(tripMetrics, themeColor)}
          </div>
        </div>

        {/* Item 2 */}
        <div
          className="w-1/2 rounded-lg items-center p-1 flex flex-col"
          style={{
            height: "8.5rem",
            boxShadow:
              "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.06), 0 -4px 6px -1px rgba(0,0,0,0.1), 0 -2px 4px -2px rgba(0,0,0,0.06)",
          }}
        >
          <div
            className="flex w-full h-1/5 items-center text-center justify-center rounded-lg text-white"
            style={{ backgroundColor: themeColor }}
          >
            <div className="flex items-center justify-center gap-2 rounded-lg p-1 text-white">
              <svg
                width="18"
                height="18"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.72048 3.65982L16.3402 15.2795C19.0455 12.0383 18.8767 7.20943 15.8336 4.16637C12.7906 1.12331 7.96171 0.954463 4.72048 3.65982ZM15.2795 16.3402L3.65982 4.72048C0.954463 7.96171 1.12331 12.7906 4.16637 15.8336C7.20943 18.8767 12.0383 19.0455 15.2795 16.3402ZM3.10571 3.10571C6.91332 -0.701903 13.0867 -0.701903 16.8943 3.10571C20.7019 6.91332 20.7019 13.0867 16.8943 16.8943C13.0867 20.7019 6.91332 20.7019 3.10571 16.8943C-0.701903 13.0867 -0.701903 6.91332 3.10571 3.10571Z"
                  fill="white"
                />
              </svg>
              <span>Cancellations</span>
            </div>
          </div>
          <div className="h-full flex flex-row space-x-1 items-center justify-center w-full bg-white">
            {renderCards(cancelMetrics, themeColor)}
          </div>
        </div>
      </div>

      <div className="w-1/3 flex space-x-2 items-center">
        <div
          className="w-1/2 flex flex-col rounded-lg p-1 items-center"
          style={{
            height: "8.5rem",
            boxShadow:
              "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.06), 0 -4px 6px -1px rgba(0,0,0,0.1), 0 -2px 4px -2px rgba(0,0,0,0.06)",
          }}
        >
          <div
            className="w-full h-1/2 items-center text-center flex flex-col justify-center rounded-lg p-1 text-white"
            style={{ backgroundColor: themeColor }}
          >
            <div className="flex items-center justify-center text-center text-white">
              <p className="text-xs">Passenger Per Head</p>
            </div>
            <div className="flex justify-between space-x-2">
              {passengerMetrics.map(({ label, value, variance }) => (
                <div key={label} className="flex flex-col">
                  <p className="text-sm font-medium text-white">
                    R{value}
                    <span
                      className="text-xxs font-thin"
                      style={{ color: variance >= 0 ? "red" : "#5DFD93" }}
                    >
                      {variance >= 0 ? `+${variance}%` : `${variance}%`}
                    </span>
                  </p>
                  <p className="text-xs text-white">{label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* second */}
          <div className="w-full h-1/2 items-center text-center flex flex-col justify-center rounded-lg p-1">
            <div className="flex items-center justify-center text-center">
              <p className="text-xs" style={{ color: themeColor }}>
                Occupancy
              </p>
            </div>
            <div className="flex justify-between space-x-2">
              {occupancyMetrics.map(({ label, value, variance }) => (
                <div key={label} className="flex flex-col">
                  <p
                    className="text-sm font-medium"
                    style={{ color: themeColor }}
                  >
                    {value}%
                    <span
                      className="text-xxs font-thin"
                      style={{ color: variance >= 0 ? "#5DFD93" : "red" }}
                    >
                      {variance >= 0 ? `+${variance}%` : `${variance}%`}
                    </span>
                  </p>
                  <p className="text-xs" style={{ color: themeColor }}>
                    {label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className="w-1/2 bg-blue-400 rounded-lg flex items-center text-center justify-center"
          style={{
            height: "8.5rem",
            backgroundColor: themeColor,
            boxShadow:
              "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.06), 0 -4px 6px -1px rgba(0,0,0,0.1), 0 -2px 4px -2px rgba(0,0,0,0.06)",
          }}
        >
          <div className="text-white text-center flex flex-col">
            <p className="text-xs">
              Estimated Cost
              <span
                className="text-xs p-2 font-thin"
                style={{
                  color: "white",
                }}
              >
                {costsData.total_costs_variance}%
              </span>
            </p>
            <p className="text-2xl font-bold">
              R
              {costsData.total_costs
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
